import axios from 'axios';
import React from 'react';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
// react plugin used to create datetimepicker
import Select from 'react-select';
// reactstrap components
import { Button, Card, CardBody, CardHeader, CardTitle, Col, Form, FormGroup, Input, Row } from 'reactstrap';
import TagsInput from 'react-tagsinput';
import { PulseLoader } from 'react-spinners';
import { loadError } from "../inputValidationUtils/load_error.js";
import { validateInput, validateSubmit } from "../inputValidationUtils/input_validation.js";
import { feedbacktype, prioritylevel } from "../../../variables/dropdowns/FeedbackDropDown.js";

class AddFeedback extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // bid Info
      file: null,
      tagsinput: [],
      alert: null,
      header: {},
      url: "",
      medialoaded: false,
    };

    this.onFileChange = this.onFileChange.bind(this);
  }
  // to stop the warning of calling setState of unmounted component
  componentWillUnmount() {
    let id = window.setTimeout(null, 0);
    while (id--) {
      window.clearTimeout(id);
    }
  }

  componentDidMount() {
    if (this.props.token) {
      this.setState(
        {
          header: {
            headers: {
              Authorization: `Token ${this.props.token}`,
            },
          },
          url: this.props.url,
          companytype: this.props.companytype,
          partnernumber: this.props.partnernumber,
          viewOnly: this.props.viewOnly ? this.props.viewOnly : false,
          userId: this.props.userId,
          feedbackId: this.props.feedbackId,
          bgcolor: document.body.classList.contains("white-content"),
        },
        () => {
          if (this.state.feedbackId) {
            this.getFeedback();
          }
        }
      );
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.token) {
      this.setState(
        {
          header: {
            headers: {
              Authorization: `Token ${newProps.token}`,
            },
          },
          url: newProps.url,
          companytype: newProps.companytype,
          partnernumber: newProps.partnernumber,
          userId: newProps.userId,
          viewOnly: newProps.viewOnly ? newProps.viewOnly : false,
          feedbackId: newProps.feedbackId,
          bgcolor: document.body.classList.contains("white-content"),
        },
        () => {
          if (this.state.feedbackId) {
            this.getFeedback();
          }
        }
      );
    }
  }

  handleTagsinput = (tagsinput) => {
    this.setState({ tagsinput });
  };
  onFileChange(e) {
    this.setState({
      file: e.target.files[0],
      medialoaded: true,
    });
  }
  getFeedback = () => {
    axios.get(this.state.url + `animo-feedback/${this.state.feedbackId}/`, this.state.header).then((res) => {
      this.setState({
        type: { value: res.data.type, label: res.data.type },
        description: res.data.description,
        summary: res.data.summary,
        priority: { value: res.data.priority, label: res.data.priority },
      });
    });
  };
  onSubmitFeedback = (event) => {
    event.preventDefault();
    if (this.state.medialoaded) {
      const formData = new FormData();
      formData.append("uploader", this.state.userId);
      formData.append("name", this.state.fileName);
      formData.append("file", this.state.file);
      formData.append("upload_type", "Feedback");

      axios.post(this.state.url + "media-files/", formData, this.state.header).then((res) => {
        this.setState({ mediaId: res.data.id }, () => {
          this.onSubmitNotes();
        });
      });
    } else {
      this.onSubmitNotes();
    }
  };
  onSubmitNotes = () => {
    let url = window.location.href;
    this.setState({ loading: true });
    // Non-nullable state items
    let stateItemsR = ["type", "description", "summary"];
    // Nullable state items
    let stateItemsN = ["priority"];
    //let rigpartner = this.state.partnernumber;

    if (validateSubmit(stateItemsR, stateItemsN, this)) {
      const feedback = {
        type: this.state.type ? this.state.type.label : "None",
        submitter: this.state.userId,
        description: this.state.description,
        summary: this.state.summary,
        active: true,
        url: url,
        priority: this.state.priority ? this.state.priority.label : "",
        media_file: this.state.medialoaded ? this.state.mediaId : null,
      };

      axios
        .post(this.state.url + "animo-feedback/", feedback, this.state.header)
        .then((res) => {
          for (let i = 0; i < this.state.tagsinput.length; i++) {
            let tags = {
              name: this.state.tagsinput[i],
              animo_feedback: res.data.id,
            };
            axios.post(this.state.url + "animo-feedback-tags/", tags, this.state.header);
          }

          let options = {};
          if (this.state.type.label === "Bug") {
            options = {
              place: "br",
              message: "This will be addressed promptly!",
              type: "info",
              icon: <i className={"tim-icons icon-tv-2"} />,
              autoClose: 5000,
            };
          } else if (this.state.type.label === "Help Request") {
            options = {
              place: "br",
              message: "We will contact you shortly",
              type: "info",
              icon: <i className={"tim-icons icon-mobile"} />,
              autoClose: 5000,
            };
          } else if (this.state.type.label === "Missing Data") {
            options = {
              place: "br",
              message: "This will be addressed promptly!",
              type: "info",
              icon: <i className={"tim-icons icon-chart-pie-36"} />,
              autoClose: 5000,
            };
          } else {
            options = {
              place: "br",
              message: "Thank you for your feedback!",
              type: "success",
              icon: <i className={"tim-icons icon-trophy"} />,
              autoClose: 5000,
            };
          }
          this.setState({ loading: false }, () => {
            toast[options.type](options.message, options);
          });
          this.clearform();
          this.props.closeModal();
        })
        .catch((error) => {
          let options = {};
          options = loadError(error);
          options.place = "br";
          this.setState({ loading: false }, () => {
            toast[options.type](options.message, options);
          });
          // this.props.closeModal()
        });
    } else {
      let options = {};
      options = {
        place: "br",
        message: "We need more info to help.",
        type: "warning",
        icon: <i className={"tim-icons icon-alert-circle-exc"} />,
        autoClose: 7000,
      };
      this.setState({ loading: false }, () => {
        toast[options.type](options.message, options);
      });
    }
  };

  clearform() {
    this.setState({
      loading: false,
      tagsinput: [],
      category: null,
      type: "",
      description: "",
      summary: "",
      priority: "",
      priorityState: "",
      typeState: "",
      descriptionState: "",
      summaryState: "",
    });
  }

  handleSelection = (Selection) => {
    this.setState({ goalName: Selection ? Selection.label : null, connectedGoal: Selection ? (Selection.__isNew__ ? false : true) : false, goalNameState: "has-success" });
  };

  render() {
    // taking all the states
    let {
      //rig info form
      typeState,
      priorityState,
      descriptionState,
      summaryState,
    } = this.state;
    return (
      <>
        <div className="content">
          {this.state.loading ? (
            <Card>
              <CardHeader className="text-right">
                <CardTitle className="pull-left" tag="h4">
                  Notifying Support Team
                </CardTitle>
              </CardHeader>
              <CardBody className="d-flex justify-content-center">
                <PulseLoader size={20} margin={"8px"} color={"#999999"} loading={this.state.loading} />
              </CardBody>
            </Card>
          ) : (
            <Form id="rigadd">
              <Card>
                <CardHeader className="text-right">
                  <CardTitle className="pull-left" tag="h4">
                    Add Feedback
                  </CardTitle>
                  <Button color="primary" onClick={this.onSubmitFeedback}>
                    Submit
                  </Button>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col lg="5" md="6" sm="12">
                      <FormGroup className={`has-label`}>
                        <label>Type</label>

                        <Select
                          className={"react-select " + typeState}
                          classNamePrefix="react-select"
                          isSearchable={true}
                          name="type"
                          isDisabled={this.state.typeRO | this.state.viewOnly ? true : false}
                          closeMenuOnSelect={true}
                          value={this.state.type}
                          option={this.state.type}
                          onChange={(option) => this.setState({ type: option, typeState: "has-success" })}
                          options={feedbacktype}
                        />
                        {this.state.typeState === "has-danger" ? <label className="error">This field is required.</label> : null}
                      </FormGroup>
                    </Col>

                    <Col lg="5" md="6" sm="12">
                      <FormGroup className={`has-label`}>
                        <label>Priority</label>

                        <Select
                          className={"react-select " + priorityState}
                          classNamePrefix="react-select"
                          isSearchable={true}
                          name="priority"
                          isDisabled={this.state.priorityRO | this.state.viewOnly ? true : false}
                          closeMenuOnSelect={true}
                          value={this.state.priority}
                          option={this.state.priority}
                          onChange={(option) => this.setState({ priority: option, priorityState: "has-success" })}
                          options={prioritylevel}
                        />
                        {this.state.priorityState === "has-danger" ? <label className="error">This field is required.</label> : null}
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <CardHeader className="text-right">
                      {this.state.type && this.state.type.label ? (
                        <CardTitle className="pull-left" tag="h4">
                          {this.state.type.label === "Bug"
                            ? "We apologize for this inconvenience. Please help us resolve the issue:"
                            : this.state.type.label === "Feature Request"
                            ? "Great! Let us know what we can do:"
                            : this.state.type.label === "Help Request"
                            ? "What can we help with?"
                            : this.state.type.label === "Missing Data"
                            ? "Please be as specific as you can so we can resovle this:"
                            : this.state.type.label === "Report Request"
                            ? "Let us know what you would like to see:"
                            : ""}
                        </CardTitle>
                      ) : null}
                    </CardHeader>
                  </Row>
                  <Row>
                    <Col lg="12" md="12" sm="12">
                      <FormGroup className={`has-label ${summaryState}`}>
                        <label>Summary</label>
                        <Input
                          name="summary"
                          value={this.state.summary}
                          type="textarea"
                          style={{ height: 77 }}
                          readOnly={this.state.viewOnly}
                          onChange={(e) => validateInput(e, this, "summary", "length", 1)}
                        />
                        {this.state.summaryState === "has-danger" ? <label className="error">This field is required.</label> : null}
                      </FormGroup>
                    </Col>
                    <Col lg="12" md="12" sm="12">
                      <FormGroup className={`has-label ${descriptionState}`}>
                        <label>Description</label>
                        <Input
                          name="description"
                          value={this.state.description}
                          type="textarea"
                          style={{ height: 187 }}
                          readOnly={this.state.viewOnly}
                          onChange={(e) => validateInput(e, this, "description", "length", 1)}
                        />
                        {this.state.descriptionState === "has-danger" ? <label className="error">This field is required.</label> : null}
                      </FormGroup>
                    </Col>
                    <Col md="12">
                      <CardTitle tag="h4">Tags</CardTitle>
                      <TagsInput onChange={this.handleTagsinput} tagProps={{ className: "react-tagsinput-tag primary" }} value={this.state.tagsinput} />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="8" md="8" sm="8">
                      <CardTitle tag="h4">Supporting File</CardTitle>
                      <input style={{ color: this.state.bgcolor ? "black" : "white" }} type="file" onChange={this.onFileChange} />
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Form>
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    obj: [...state.obj],
    token: state.token,
    url: state.url,
    error: state.error,
    userId: state.userId,
    companytype: state.userPartnerType,
    partnernumber: state.userPartner,
  };
};

export default connect(mapStateToProps, null)(AddFeedback);
